import { Injectable } from '@angular/core';
import { SurveyDataResolve } from '../shared';
import { SurveyDataInterface } from '../../classes';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class ComposeResolve implements Resolve<Partial<SurveyDataInterface>> {
    constructor (
        private surveyData:SurveyDataResolve,
    ) {}
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Partial<SurveyDataInterface>> {
        return this.surveyData.resolve(route, state);

    }
    
}
